export default "__VITE_ASSET__f63d836e__"